// FolderIcon.jsx

import { FolderIcon as BaseFolderIcon } from "@heroicons/react/24/outline";

const FolderIcon = (props) => {
  return <BaseFolderIcon {...props} />;
};

export default FolderIcon;
